var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { Tab } from 'semantic-ui-react';
import styled from 'styled-components';
var StyledTabPane = styled(Tab.Pane)(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
Object.assign(StyledTabPane, {
    displayName: 'TabPane',
});
export default StyledTabPane;
var templateObject_1;
//# sourceMappingURL=pane.js.map